// Angular
import { Component, Input, ViewRef, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationService } from '../../notification-result/notification-service/notification.service';

@Component({
	selector: 'kt-notification',
	templateUrl: './notification.component.html',
})
export class NotificationComponent {


	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon: string = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';

	totalNof: number = 0;

	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(private sanitizer: DomSanitizer, 
		private service: NotificationService,
		private changeDetect: ChangeDetectorRef,) {
		this.totalNof = this.service.totalNof$.getValue();
	}

	ngOnInit(): void {
		setInterval(r => {

			this.totalNof = this.service.totalNof$.getValue();
			this.changeDetectView();
		}, 0)
		
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}

	toggled(event) {
		if (event) {
			this.service.isOpenNotifyDropdown$.next(true);
			
		} else {
			this.service.isOpenNotifyDropdown$.next(false);
		}
	  }

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
}
